import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('chats');

export const check = () => useBasicAuth.checkToken();
export const checkTokenExists = () => useBasicAuth.checkTokenExists();

export const addChat = (request) => 
  axios.post(urlAPI + '/addChat', JSON.stringify(request), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllChatByUser = (id) => 
  axios.get(urlAPI + "/byUser/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllChatByUserNotRead = (id) => 
  axios.get(urlAPI + "/byUserNotRead/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllChatByUserNotReadTopbar = (id) => 
  axios.get(urlAPI + "/byUserNotRead/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
  });

export const send = (request) => 
  axios.post(urlAPI + "/send" , JSON.stringify(request), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const markAsReceived = (id) => 
  axios.get(urlAPI + "/markAsReceived/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const markAsRead = (id) => 
  axios.get(urlAPI + "/markAsRead/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  